import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";

const Development = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
      <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
      <meta name="format-detection" content="telephone=no" />
      <title>Top Salesforce Development Consultant</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta
        name="description"
        content="Codezix is a top Salesforce development consultant delivering custom Salesforce applications, Apex development, Lightning components, API integrations, automation, and scalable CRM solutions tailored to business needs."
      />
      <meta
        name="keywords"
        content="Salesforce development company, Salesforce developer services, Apex development, Lightning Web Components, Salesforce CRM development, custom Salesforce app development, Salesforce API integration"
      />

      {/* BreadcrumbList (New York page) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Salesforce Development",
      "item": "https://www.codezix.com/salesforce/development"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Salesforce Development Company in New York",
      "item": "https://www.codezix.com/salesforce/development-company-in-new-york"
    }
  ]
}
        `}
      </script>

      {/* Organization */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://codezix.com/assets/images/logo.webp",
    "width": 250,
    "height": 80
  },
  "image": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce consulting and cloud solution provider helping enterprises accelerate their digital transformation journey with expert CRM and cloud engineering.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ]
}
        `}
      </script>

      {/* WebSite */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
        `}
      </script>

      {/* WebPage (New York page) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.codezix.com/salesforce/development-company-in-new-york#webpage",
  "url": "https://www.codezix.com/salesforce/development-company-in-new-york",
  "name": "Top Salesforce Development Consultant",
  "inLanguage": "en-US",
  "description": "Custom Salesforce development services including Apex, Lightning Components, Visualforce, integrations, workflow automation, and fully tailored CRM solutions for enterprise growth.",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  }
}
        `}
      </script>

      {/* Service — New York Development Page (separate) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development-company-in-new-york#service",
  "url": "https://www.codezix.com/salesforce/development-company-in-new-york",
  "serviceType": "Salesforce Development Services",
  "name": "Salesforce Development Company in New York",
  "description": "Salesforce development company in New York offering Apex development, Lightning Web Components, API integrations, workflow automation, and custom CRM solutions tailored for enterprises in the US.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "New York"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Salesforce Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Apex & Lightning Web Component Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Salesforce API Integration & Middleware"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Salesforce Applications & Automation"
        }
      }
    ]
  }
}
        `}
      </script>

      {/* Service — Global Development (original /development service block) */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/development#service",
  "url": "https://www.codezix.com/salesforce/development",
  "serviceType": "Salesforce Development & Custom Engineering",
  "name": "Top Salesforce Development Consultant",
  "description": "Custom Salesforce development services including Apex, Lightning Components, Visualforce, integrations, workflow automation, and fully tailored CRM solutions for enterprise growth.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Global"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Salesforce Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Apex & Lightning Web Component Development"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Salesforce API Integration & Middleware"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Salesforce Applications & Automation"
        }
      }
    ]
  }
}
        `}
      </script>

      {/* ContactPoint */}
      <script type="application/ld+json">
        {`
{
  "@context": "https://schema.org",
  "@type": "ContactPoint",
  "contactType": "customer support",
  "telephone": "+1-917-730-7436",
  "email": "info@codezix.com",
  "areaServed": ["US","UK","AE","DE","KW","AU"],
  "availableLanguage": ["English"]
}
        `}
      </script>
    </Helmet>



            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Application Development</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/development.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">

                        <div className="salesforce-service bottom">
                            <p className="prose-lg wow fadeUp">
                                Salesforce application development services are designed to enhance sales, marketing, and customer service processes that go beyond the capabilities of standard Salesforce CRM. With expertise in CRM development since 2014, Codezix delivers dependable custom Salesforce applications and AppExchange solutions, tailored to meet your unique business requirements.
                            </p>
                        </div>

                        <div className="sasesforce-benifit">
                            <div className='explore-heading text-left'>
                                <h2>Key Benefits of Building Custom Salesforce Apps</h2>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>545% </h3>
                                        <p className="wow fadeUp prose-lg">five-year ROI</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>6 months </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales revenue</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>83% </h3>
                                        <p className="wow fadeUp prose-lg">less unplanned downtime</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="selesforce-services top">
                            <div className='explore-heading text-left'>
                                <h2>Types of Salesforce Apps We Build</h2>
                                <p className="wow fadeUp prose-lg text-left">We develop robust, high-quality applications that ensure Salesforce comprehensively addresses our clients' or their customers' business needs, driving improvements or transformations in sales, marketing, and customer service processes. Additionally,
                                    {" "} <a
                                        href="https://www.codezix.com/salesforce/development-company-in-new-york"
                                        className="text-blue-600 underline"
                                        target="_blank"
                                    >
                                        we create apps
                                    </a>{" "}
                                      that gain widespread popularity and achieve top rankings on AppExchange.</p>
                            </div>

                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="plateform">
                                        <h3 className="mt-4">Custom applications for internal use.</h3>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg">Sophisticated applications that enhance Salesforce with significant functionality, addressing internal business processes that go beyond the capabilities of standard CRM features. Examples include applications for property management or delivery scheduling.</li>
                                                <li className="wow fadeUp prose-lg mt-3"> Compact applications designed to handle specific tasks within Salesforce, such as document generation or lead assignment.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="plateform">
                                        <h3 className="mt-4">Level 2. Salesforce customization</h3>
                                        <div className="why-listing mt-4">
                                            <ul>
                                                <li className="wow fadeUp prose-lg"> Applications designed to be listed on AppExchange, turning them into an independent revenue stream.</li>
                                                <li className="wow fadeUp prose-lg mt-3">Applications designed for listing on AppExchange to integrate a company’s product (such as a cloud platform or web application) with Salesforce.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforc-services">
                            <div className='explore-heading text-left'>
                                <h2>Comprehensive Salesforce Development Solutions </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Business or requirements analysis</h3>
                                        <p className="wow fadeUp prose-lg">Our process begins with business analysis when developing a custom application for internal use. Initially, we conduct individual or group interviews with stakeholders to gather and elicit their requirements. We then analyze these requirements, addressing any conflicts, and prioritize them to ensure that the most essential features are delivered first. The result is a detailed report outlining the prioritized business, functional, and system requirements, solidifying a shared vision for both the business and technical aspects of the application. Our Business Analysis team remains in constant communication with the customer throughout the project to accommodate any evolving or new requirements.</p>
                                        <p className="wow fadeUp prose-lg">The first step in building an AppExchange application is requirements analysis. We begin by thoroughly examining our customer’s needs, ensuring they are consistent and well-defined. We then refine these requirements and determine the most effective technical solutions to meet them. This approach ensures that the resulting application is both highly efficient and fully compliant with Salesforce’s system and security standards.</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/consulting.png')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>UI/UX design</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We enhance Salesforce applications by designing intuitive user journeys and developing responsive UI prototypes to ensure a seamless and user-friendly experience.                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/analyse.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Development</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We develop applications with comprehensive functionality in small, prioritized iterations to deliver key features early. To maintain flexibility and quickly adapt to evolving customer needs, we first create a functional baseline that’s ready to use. This enables us to rapidly add additional features based on the demands of end users or the product owner. Users can start benefiting from the app immediately, with new features typically rolled out every 2-4 weeks after the initial baseline for internal-use apps.
                                            <p className="wow fadeUp prose-lg">For smaller apps, we focus on a swift, single-delivery approach, ensuring it aligns with the app's size and purpose.</p>
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/integration.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Quality assurance</h3>
                                        <p className="wow fadeUp prose-lg">
                                            To guarantee the high quality and stable performance of our Salesforce applications, we conduct a thorough set of QA activities, including unit tests and code reviews, led by our Salesforce developers. Continuous testing is integrated throughout the development process, covering functional, performance, and integration testing (when required). Additionally, we implement a strategic level of test automation to accelerate delivery while minimizing bugs.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/CRM.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Necessary integrations</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We integrate custom internal-use applications with third-party software, such as content management systems, using either Salesforce's built-in integration tools or custom-built solutions tailored to meet specific needs.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/training.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>User training</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We offer comprehensive training materials and hands-on sessions to end users, ensuring smooth adoption and effective use of custom internal applications.                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/launch.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Launch</h3>
                                        <p className="wow fadeUp prose-lg">
                                            When launching custom internal applications, we first transfer the tested application to the User Acceptance Testing (UAT) environment. Once the customer approves the application, it is then migrated to the production environment and made available to end users.
                                        </p>
                                        <p className="wow fadeUp prose-lg">
                                            When launching an application on AppExchange, we prepare it for the AppExchange security review by creating detailed documentation for both end users and administrators. This documentation is submitted to the Salesforce Product Security Team. Additionally, we provide credentials for the Lightning Platform org and any external components or services used in the app's development.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/support.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>After-launch support</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We offer post-launch support for custom internal applications for 1-3 months after deployment. During this period, we fine-tune the application's features and take additional steps to drive user adoption, such as providing release notes and addressing user issues as they arise.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src="https://www.scnsoft.com/colorful-icons/support.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix top">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is proud to be recognized as a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in IT business.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in CRM services.</li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board.</li>
                                    <li className="wow fadeUp prose-lg">Expertise across industries such as manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                </ul>
                            </div>

                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-product ">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Products We Implement</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix’s Salesforce team is ready to support you in implementing:</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/customization#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='achieve-project mb-4'>
                            <button className="prose-md">What makes Codezix different</button>
                            <h3>We ensure project success, no matter the circumstances</h3>
                            <p>Codezix does not pass mere project administration off as project management, which, unfortunately, is a common practice in the market. We practice real project management, ensuring project success for our clients no matter what.</p>
                            <Link to="/"> <button>See how we do it&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Our Methodology for Salesforce Application Development</h2>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-1.webp')} alt="" />
                                        </div>
                                    </div>

                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"> Efficient project management is key when developing custom applications for internal use. We work closely with stakeholders on the customer’s side to gather and prioritize requirements, ensuring the application's functionality aligns perfectly with their needs. We remain flexible throughout the project, quickly adapting the application to new or changing requirements at every stage.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-2.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">We apply mature technical project management practices when building applications for AppExchange. Our well-established processes for scheduling, budget management, and developer coordination, along with robust risk management strategies, enable us to deliver high-quality apps on time while preventing scope and cost creep. The close collaboration between our project manager and technical team ensures the app is fully aligned with its original concept, meets the customer’s requirements, and adheres to Salesforce’s technical and security standards.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-3.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Flexible delivery models tailored to needs. For specialized applications addressing specific tasks within a CRM domain, we can deliver the complete application in one go. For more comprehensive business applications, we use an iterative approach. This allows end customers to begin using the app with its basic features right away, while we continue to enhance the application based on feedback from product owners and users, adding new features in response to evolving needs.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-4.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg">Commitment to quality. As an ISO 9001-certified company, we implement a robust quality management system to deliver flawless apps that perform as expected and offer a seamless, intuitive user experience. Through regular unit testing and code reviews, we ensure a high-quality architecture and codebase, making the application easy to maintain, modify, and evolve over time.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-5.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Long-term support and continuous evolution.</strong> Our partnership with clients extends beyond the application's launch. We consistently adapt applications to meet evolving business needs by enhancing existing features or adding new functionality, ensuring the app remains aligned with changing requirements over time.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-6.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Reasonable costs.</strong>Drawing on our extensive project management experience, we select the most appropriate delivery model—whether at-once or iterative—and effectively prioritize developers' time. This approach maximizes their performance, ensuring the timely delivery of software without rework or delays. As a result, we prevent scope and cost creep, delivering cost-effective applications without compromising on quality.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="inner-salesforce-service mt-4">
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="innner-service-logo">
                                            <img src={require('../../assets/images/development/dev-7.webp')} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="innner-service-text">
                                            <p className="wow fadeUp prose-lg"><strong>Flexibility in terms of a project’s timeline.</strong> We are adaptable when it comes to changes in a project’s start date or key development phases. If a customer decides to adjust the project timeline, we will seamlessly accommodate the change and adjust our approach accordingly.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services top">
                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Cooperation Models</h2>
                                    <p className="wow fadeUp prose-lg text-left">We offer various cooperation models based on the type of Salesforce app being developed, whether it's a custom app for internal use or an app for AppExchange:</p>
                                </div>

                                <div className="why-listing mt-4">
                                    <ul>
                                        <li className="wow fadeUp prose-lg"><strong>End-to-end delivery from scratch (custom applications for internal use).</strong><br />
                                            We offer full-cycle application delivery, starting with analyzing the customer’s business needs and gathering high-level requirements, all the way through to user training and ongoing support for the custom app. Using Agile methodology, we remain flexible throughout the development process, adapting to new or changing requirements and seamlessly incorporating them into the app's functionality.</li>
                                        <li className="wow fadeUp prose-lg"><strong>Development tailored to the customer’s requirements (AppExchange apps).</strong> <br />
                                            We take into account the detailed business, functional, and system requirements of our clients, transforming their vision into a reliable app that stands out on AppExchange. This app either becomes a standalone revenue source or enhances the sale of the main software product by facilitating seamless integration with Salesforce. In cases where integration is key, we identify the most effective way to overcome Salesforce API limitations and create an AppExchange integration app that ensures smooth data flow between connected systems.</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="salesforce-product ">
                                <div className='explore-heading text-left'>
                                    <h2>Technologies and Tools We Use </h2>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="why-listing mt-4">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg">Apex code</li>
                                                    <li className="wow fadeUp prose-lg">Visualforce</li>
                                                    <li className="wow fadeUp prose-lg">Customer 360 Platform</li>
                                                    <li className="wow fadeUp prose-lg">Lightning Web Components</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="why-listing mt-4">
                                                <ul>
                                                    <li className="wow fadeUp prose-lg">Site.com</li>
                                                    <li className="wow fadeUp prose-lg">REST/SOAP API</li>
                                                    <li className="wow fadeUp prose-lg">JavaScript frameworks</li>
                                                    <li className="wow fadeUp prose-lg">Salesforce 1</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-shadow top_padding">
                                <div className="row mb-4">
                                    <div className="valuation-box">
                                        <div className="col-md-9">
                                            <h3>Let’s Build Your App</h3>
                                            <p className="prose-lg wow fadeUp">Receive a free consultation on achieving your business goals with Salesforce applications.</p>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="button_exp mt-5">
                                                <Link to="/contact"><button>Contact </button> </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Development;